import { render, staticRenderFns } from "./ApprovalFlowTransactionDetails.vue?vue&type=template&id=124a3915&"
import script from "./ApprovalFlowTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./ApprovalFlowTransactionDetails.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalFlowTransactionDetails.vue?vue&type=style&index=0&id=124a3915&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('124a3915')) {
      api.createRecord('124a3915', component.options)
    } else {
      api.reload('124a3915', component.options)
    }
    module.hot.accept("./ApprovalFlowTransactionDetails.vue?vue&type=template&id=124a3915&", function () {
      api.rerender('124a3915', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/security/approval-flow-transaction/ApprovalFlowTransactionDetails.vue"
export default component.exports